import { defaultCap } from '@anm/data/streaming/destinationsCaps';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, ChangeEvent } from 'react';

type HookProps = {
  text: string;
  titleMaxLength?: number;
  onTextChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

type ValidateProps = {
  titleMaxLength?: number;
};

export const max_description_length = defaultCap.descriptionMaxLength;

export const isValidText = (value: string, titleMaxLength?: number) =>
  value.length >= 1 && value.length <= (titleMaxLength ? titleMaxLength : max_description_length);

const useValidateTextField = ({ text, titleMaxLength, onTextChange }: HookProps) => {
  const [isError, setError, unsetError] = useSwitchState();

  const handleTextChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onTextChange(e);
      isValidText(e.target.value, titleMaxLength) ? unsetError() : setError();
    },
    [onTextChange, titleMaxLength]
  );

  const validateName = (props: ValidateProps | null = null) => {
    !isValidText(text, props?.titleMaxLength) && setError();

    return isValidText(text, titleMaxLength);
  };

  return [isError, validateName, handleTextChange] as const;
};

export default useValidateTextField;
